/* Dedicated Luvano checkout page. The server owns pricing and order status. */
(function () {
  'use strict';

  const root = document.querySelector('[data-luvano-pay]');
  if (!root) return;

  const apiBase = 'https://tryluvano.co/app/api/integrations/paysight/sessions/';
  const sdkUrl = 'https://payment.paysight.io/widget-sdk.js';
  const productId = 13157;
  const returnPaths = new Set([
    '/products/luvano-ceylon-cinnamon',
    '/products/luvano-cozy-crescent-pillow',
    '/products/luvano-little-explorer-backpack-pillow',
  ]);
  const sportReturnUrl = 'https://luvanosport.com/';
  const copy = {
    free: 'Free',
    loading: 'Loading checkout…',
    processing: 'Confirming payment and order…',
    errorRetry: 'Payment could not be completed. Please try again.',
    successHeading: 'Order confirmed',
    successBody: 'Your order has been placed.',
    expired: 'This checkout link has expired. Return to the product page and try again.',
    unavailable: 'Checkout is temporarily unavailable. Return to the product page and try again.',
    paysightUnavailable: 'Checkout is temporarily unavailable. Please try again.',
    verificationDelayed: "We're checking this payment. Please do not pay again while we confirm the order.",
    reviewHeading: 'Payment under review',
    reviewBeforeHelp: 'Please do not pay again. Contact the ',
    reviewAfterHelp: ' and include this checkout page link so we can locate your payment.',
    offerProcessing: 'Confirming your added item…',
    offerError: 'The added item could not be charged. Please try again.',
  };

  const files = 'https://cdn.shopify.com/s/files/1/0743/2919/4683/';
  const returnsBadge = files + 't/2/assets/lvb-v4-returns-badge.svg';
  const familyViews = {
    dog: {
      collection: 'COZY CRESCENT COLLECTION',
      thumbs: [
        files + 'files/variant-yellow.png?v=1789574736',
        files + 'files/variant-blue.png?v=1789574738',
        files + 'files/variant-pink.png?v=1789574741',
      ],
      tagline: 'A soft spot for their favorite corner.',
      storyTitle: 'MADE FOR THEIR FAVORITE SPOT',
      kicker: 'THE LITTLE DETAILS',
      benefits: ['Soft, textured plush', 'Curved shape for a cozy chin rest', 'Yellow, Blue or Pink'],
      gallery: [
        files + 't/3/assets/life-beagle.png?v=1789572101',
        files + 't/3/assets/life-corgi.png?v=1789572104',
        files + 't/3/assets/life-desk.png?v=1789572108',
        files + 'files/luvano-pillow-lifestyle_923b5a81-836e-4056-91a8-c8d4d131e8c9.png?v=1789570141',
      ],
    },
    babyguard: {
      collection: 'LITTLE EXPLORER COLLECTION',
      thumbs: [files + 't/2/assets/lvb-v4-studio.jpg', files + 't/2/assets/lvb-v4-casual-0.jpg', files + 't/2/assets/lvb-v4-life-play.jpg'],
      tagline: 'A softer landing for everyday adventures.',
      storyTitle: 'MADE FOR YOUR LITTLE EXPLORER',
      kicker: 'THE LITTLE DETAILS',
      graphic: files + 't/2/assets/lvb-v4-checkout-assurance-clear.png?v=2',
      benefits: ['Soft cushioning', 'Adjustable straps', 'Lightweight design'],
      gallery: [0, 1, 2, 3].map(n => files + 't/2/assets/lvb-v4-casual-' + n + '.jpg'),
    },
    cinnamon: {
      collection: 'CEYLON CINNAMON COLLECTION',
      thumbs: Array(3).fill(files + 'files/cinnamon-studio.png?v=1789586179'),
      tagline: 'A simple addition to your everyday routine.',
      storyTitle: 'MADE FOR YOUR ROUTINE',
      kicker: 'INGREDIENTS & FORMULA',
      ingredients: [
        [files + 't/2/assets/luvano-cinnamon-ingredient-ceylon-20260924-v1_300x300.png?v=1790236568', 'Ceylon cinnamon extract (12:1)'],
        [files + 't/2/assets/luvano-cinnamon-ingredient-mct-20260924-v1_300x300.png?v=1790236741', 'MCT oil'],
      ],
      formatImage: files + 't/2/assets/luvano-cinnamon-format-softgels-20260924-v1_120x120.png?v=1790236761',
    },
    sport: {
      collection: 'LUVANO 3D COLLECTION',
      thumbs: [],
      detailImages: [
        files + 'files/approved-e0505222acec5b5e.jpg?v=1790179594',
        files + 'files/approved-4f6a05cab8fa12b8.jpg?v=1790179671',
        files + 'files/approved-8121d8ca86a41feb.jpg?v=1790179664',
      ],
      tagline: 'Your chosen styles, ready for everyday wear.',
      storyTitle: 'MADE FOR YOUR EVERYDAY WARDROBE',
      kicker: 'THE LITTLE DETAILS',
      benefits: ['High-waisted fit', 'Stretchy, textured 3D knit', 'Your selected color and size'],
    },
  };

  const linesNode = root.querySelector('[data-lines]');
  const totalNode = root.querySelector('[data-total]');
  const subtotalNode = root.querySelector('[data-subtotal]');
  const shippingNode = root.querySelector('[data-shipping]');
  const summaryToggle = root.querySelector('[data-summary-toggle]');
  const summaryToggleTotal = root.querySelector('[data-summary-toggle-total]');
  const localEstimatePayment = root.querySelector('[data-local-estimate-payment]');
  const localEstimateSummary = root.querySelector('[data-local-estimate-summary]');
  const summaryBody = root.querySelector('[data-summary-body]');
  const collection = root.querySelector('[data-collection]');
  const collectionImages = root.querySelector('[data-collection-images]');
  const collectionTitle = root.querySelector('[data-collection-title]');
  const headerBenefits = root.querySelector('[data-header-benefits]');
  const intro = root.querySelector('[data-intro]');
  const introHeading = root.querySelector('[data-intro-heading]');
  const introBody = root.querySelector('[data-intro-body]');
  const tagline = root.querySelector('[data-tagline]');
  const reservation = root.querySelector('[data-reservation]');
  const reservationClock = root.querySelector('[data-reservation-clock]');
  const story = root.querySelector('[data-story]');
  const paymentCard = root.querySelector('[data-payment-card]');
  const customerForm = root.querySelector('[data-customer-form]');
  const customerRetryNote = root.querySelector('[data-customer-retry-note]');
  const billingFields = root.querySelector('[data-billing-fields]');
  const billingSameInput = root.querySelector('[name="billingSameAsShipping"]');
  const shippingCountryInput = root.querySelector('[data-shipping-country]');
  const shippingProvinceInput = root.querySelector('[name="province"]');
  const shippingProvinceSelect = root.querySelector('[data-province-select]');
  const phonePrefixSelect = root.querySelector('[name="phonePrefix"]');
  const shippingMethodMessage = root.querySelector('[data-shipping-method-message]');
  const paymentSubmit = root.querySelector('[data-payment-submit]');
  const result = root.querySelector('[data-result]');
  const resultHeading = root.querySelector('[data-result-heading]');
  const resultBody = root.querySelector('[data-result-body]');
  const returnButton = root.querySelector('[data-return-button]');
  const returnLink = root.querySelector('[data-return-link]');
  const brandLink = root.querySelector('[data-brand-link]');
  const statusNode = root.querySelector('[data-status]');
  const params = new URLSearchParams(location.search);
  const sessionId = params.get('s') || '';
  const pendingKey = 'luvano-payment-pending:' + sessionId;
  const paymentStartedKey = 'luvano-payment-started:' + sessionId;
  const originalPaymentKey = 'luvano-paysight-original:' + sessionId;
  let money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const currencyNote = root.querySelector('[data-currency-note]');
  const currencyHelper = window.LuvanoCurrency;
  let estimateCurrency = '';
  let estimateAmountCents = 0;
  let estimateRates = null;
  let estimateRequestStarted = false;
  let sdkPromise;
  let widget;
  let widgetReady = false;
  let paymentSubmitting = false;
  let customerLocked = false;
  let configUpdateWaiter;
  let timer;
  let offerCountdown;
  let reservationCountdown;
  let reservationDeadline = NaN;
  let serverClockOffsetMs = 0;
  let paymentSignaled = false;
  let paymentStartedRecovered = false;
  let reviewing = false;
  let openedAt = Date.now();
  let summaryOpen = false;
  let baseSession;
  let activationPromise;
  let activationComplete = false;
  let currentOffer;
  let currentChild;
  let upsellWidget;
  let upsellWidgetSessionId = '';
  let upsellSubmitting = false;
  let upsellError = false;
  let upsellBusy = false;
  const offerCard = root.querySelector('[data-offer-card]');
  const offerImage = root.querySelector('[data-offer-image]');
  const offerEyebrow = root.querySelector('[data-offer-eyebrow]');
  const offerHeadline = root.querySelector('[data-offer-headline]');
  const offerSubheading = root.querySelector('[data-offer-subheading]');
  const offerTimer = root.querySelector('[data-offer-timer]');
  const offerHook = root.querySelector('[data-offer-hook]');
  const offerAcceptTop = root.querySelector('[data-offer-accept-top]');
  const offerDescription = root.querySelector('[data-offer-description]');
  const offerInlineWarning = root.querySelector('[data-offer-inline-warning]');
  const offerBenefits = root.querySelector('[data-offer-benefits]');
  const offerCompare = root.querySelector('[data-offer-compare]');
  const offerOption = root.querySelector('[data-offer-option]');
  const offerTitle = root.querySelector('[data-offer-title]');
  const offerRating = root.querySelector('[data-offer-rating]');
  const offerRatingLabel = root.querySelector('[data-offer-rating-label]');
  const offerPrice = root.querySelector('[data-offer-price]');
  const offerSavings = root.querySelector('[data-offer-savings]');
  const offerAccept = root.querySelector('[data-offer-accept]');
  const offerGuarantee = root.querySelector('[data-offer-guarantee]');
  const offerAcceptSecondary = root.querySelector('[data-offer-accept-secondary]');
  const offerDecline = root.querySelector('[data-offer-decline]');
  const offerWarning = root.querySelector('[data-offer-warning]');
  const offerWarningLead = root.querySelector('[data-offer-warning-lead]');
  const offerWarningBody = root.querySelector('[data-offer-warning-body]');
  const offerWarningEmphasis = root.querySelector('[data-offer-warning-emphasis]');
  const offerStatus = root.querySelector('[data-offer-status]');
  const offerWidgetTarget = root.querySelector('[data-offer-widget]');

  function status(message, error) {
    statusNode.textContent = message;
    statusNode.classList.toggle('is-error', Boolean(error));
  }

  function clearReservationCountdown() {
    clearTimeout(reservationCountdown);
    reservationCountdown = undefined;
    reservation.hidden = true;
  }

  function renderReservationCountdown(session) {
    clearReservationCountdown();
    reservationDeadline = session && typeof session.expiresAt === 'string' ? Date.parse(session.expiresAt) : NaN;
    const serverNow = session && typeof session.serverNow === 'string' ? Date.parse(session.serverNow) : NaN;
    serverClockOffsetMs = Number.isFinite(serverNow) ? serverNow - Date.now() : 0;
    if (!Number.isFinite(reservationDeadline) || session.status !== 'open' || session.checkoutVersion !== 2) return;
    const tick = () => {
      if (paymentSubmitting || paymentSignaled || reviewing || baseSession?.status !== 'open') {
        clearReservationCountdown();
        return;
      }
      const seconds = Math.max(0, Math.ceil((reservationDeadline - Date.now() - serverClockOffsetMs) / 1000));
      if (seconds === 0) {
        clearReservationCountdown();
        paymentSubmit.disabled = true;
        refresh().catch(() => showResult(copy.unavailable, '', returnButton.dataset.hasProduct === 'true'));
        return;
      }
      reservationClock.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
      reservation.hidden = false;
      reservationCountdown = setTimeout(tick, 1000);
    };
    tick();
  }

  function setOfferPresentation(active, step) {
    if (active) {
      root.dataset.offerActive = 'true';
      root.dataset.offerStep = step || '';
    } else {
      delete root.dataset.offerActive;
      delete root.dataset.offerStep;
    }
    document.body.classList.toggle('lv-checkout-page--offer', active);
  }

  function showResult(heading, body, allowReturn) {
    clearTimeout(timer);
    clearTimeout(offerCountdown);
    clearReservationCountdown();
    setOfferPresentation(false);
    paymentCard.hidden = true;
    offerCard.hidden = true;
    returnLink.hidden = !allowReturn;
    result.hidden = false;
    resultHeading.textContent = heading;
    resultBody.textContent = body || '';
    resultBody.hidden = !body;
    returnButton.hidden = !allowReturn;
    status('', false);
    resultHeading.focus({ preventScroll: true });
  }

  function showProcessing(delayed) {
    clearReservationCountdown();
    const firstView = result.hidden;
    setOfferPresentation(false);
    paymentCard.hidden = true;
    offerCard.hidden = true;
    returnLink.hidden = true;
    result.hidden = false;
    resultHeading.textContent = copy.processing;
    resultBody.textContent = delayed ? copy.verificationDelayed : '';
    resultBody.hidden = !delayed;
    returnButton.hidden = true;
    status('', false);
    if (firstView) resultHeading.focus({ preventScroll: true });
  }

  function showReview(postPurchase) {
    clearReservationCountdown();
    reviewing = true;
    const firstView = result.hidden;
    setOfferPresentation(Boolean(postPurchase), currentOffer && currentOffer.step);
    paymentCard.hidden = true;
    offerCard.hidden = true;
    returnLink.hidden = true;
    result.hidden = false;
    resultHeading.textContent = copy.reviewHeading;
    const help = document.createElement('a');
    help.href = 'https://tryluvano.co/help';
    help.textContent = 'Luvano Help Center';
    resultBody.replaceChildren(
      document.createTextNode(copy.reviewBeforeHelp),
      help,
      document.createTextNode(copy.reviewAfterHelp),
    );
    resultBody.hidden = false;
    returnButton.hidden = true;
    status('', false);
    if (firstView) resultHeading.focus({ preventScroll: true });
  }

  function setReturnPath(path, family) {
    if (family === 'sport' && path !== '/' && path !== sportReturnUrl) return;
    if (family !== 'sport' && !returnPaths.has(path)) return;
    const url = family === 'sport' ? new URL(sportReturnUrl) : new URL(path, 'https://tryluvano.co');
    returnLink.href = url.toString();
    brandLink.href = url.toString();
    returnButton.href = url.toString();
    returnButton.dataset.hasProduct = 'true';
  }

  function node(tag, className, value) {
    const item = document.createElement(tag);
    if (className) item.className = className;
    if (value !== undefined) item.textContent = value;
    return item;
  }

  function photo(url, alt, className) {
    const item = node('img', className);
    item.src = url;
    item.alt = alt;
    item.loading = 'lazy';
    return item;
  }

  function syncSummary() {
    const collapsible = window.matchMedia('(max-width: 1023px)').matches && root.dataset.family !== 'cinnamon';
    summaryToggle.hidden = !collapsible;
    summaryBody.hidden = collapsible && !summaryOpen;
    summaryToggle.setAttribute('aria-expanded', String(collapsible && summaryOpen));
    root.querySelector('[data-summary-chevron]').textContent = summaryOpen ? '⌃' : '⌄';
  }

  summaryToggle.addEventListener('click', () => {
    summaryOpen = !summaryOpen;
    syncSummary();
  });
  window.addEventListener('resize', syncSummary);

  function renderStory(family, view) {
    const heading = node('h2');
    heading.append(node('span', 'lv-checkout__story-heart', '♥ '), document.createTextNode(view.storyTitle));
    story.append(heading, node('p', 'lv-checkout__story-kicker', view.kicker));

    if (family === 'sport') {
      const details = node('div', 'lv-checkout__sport-details');
      view.detailImages.forEach((url, index) => {
        const crop = node('div', 'lv-checkout__sport-detail-crop');
        crop.append(photo(url, '3D Leggings detail ' + (index + 1)));
        details.append(crop);
      });
      story.append(details);
    } else if (view.graphic) {
      const graphic = node('div', 'lv-checkout__story-graphic');
      graphic.append(photo(view.graphic, 'Little Explorer pillow details'));
      story.append(graphic);
    } else if (family === 'dog') {
      const colors = node('div', 'lv-checkout__dog-colors');
      view.thumbs.forEach((url, index) => colors.append(photo(url, ['Yellow', 'Blue', 'Pink'][index] + ' crescent pillow')));
      story.append(colors);
    } else if (family === 'cinnamon') {
      const formula = node('section', 'lv-checkout__formula');
      const ingredients = node('ul', 'lv-checkout__formula-ingredients');
      view.ingredients.forEach(([url, label]) => {
        const ingredient = node('li');
        ingredient.append(photo(url, ''), node('span', '', label));
        ingredients.append(ingredient);
      });
      const format = node('div', 'lv-checkout__formula-format');
      format.append(photo(view.formatImage, ''), node('span', '', '30 softgels per pouch'));
      formula.append(ingredients, format, node('p', 'lv-checkout__formula-note', 'See the pouch label for the complete ingredient list.'));
      story.append(formula);
    }

    if (view.benefits) {
      const list = node('ul', 'lv-checkout__story-benefits');
      view.benefits.forEach(label => list.append(node('li', '', label)));
      story.append(list);
    }
    if (view.gallery) {
      const gallery = node('div', 'lv-checkout__story-circles');
      view.gallery.forEach((url, index) => gallery.append(photo(url, family + ' product moment ' + (index + 1))));
      gallery.append(node('span', '', '+'));
      story.append(gallery);
    }
    const returns = node('div', 'lv-checkout__returns');
    returns.append(photo(returnsBadge, ''), node('strong', '', '30-day returns'));
    const conditions = node('p', 'lv-checkout__returns-copy', 'Request a return within 30 days. ');
    const conditionsLink = node('a', '', 'See conditions.');
    conditionsLink.href = family === 'sport'
      ? 'https://luvanosport.com/store/leggins?policy=refund-policy'
      : 'https://tryluvano.co/policies/refund-policy';
    conditions.append(conditionsLink);
    const support = node('p', 'lv-checkout__support', 'Questions? ');
    const supportLink = node('a', '', 'We’re here to help.');
    supportLink.href = family === 'sport'
      ? 'https://luvanosport.com/store/leggins?policy=contact-information'
      : 'https://tryluvano.co/help';
    support.append(supportLink);
    story.append(returns, conditions, support);
    story.hidden = false;
  }

  function renderFamily(family) {
    if (root.dataset.family === family) return;
    const view = familyViews[family];
    if (!view) return;
    root.dataset.family = family;
    document.body.classList.toggle('lv-checkout-page--sport', family === 'sport');
    if (family === 'sport') {
      const sportPolicies = {
        refund: 'refund-policy', shipping: 'shipping-policy', privacy: 'privacy-policy',
        contact: 'contact-information', terms: 'terms-of-service',
      };
      root.querySelectorAll('[data-policy]').forEach(link => {
        const policy = sportPolicies[link.dataset.policy];
        if (policy) link.href = 'https://luvanosport.com/store/leggins?policy=' + policy;
      });
    }
    if (family === 'sport' && root.dataset.sportWordmark) {
      root.querySelector('.lv-checkout__brand img').src = root.dataset.sportWordmark;
    }
    const thumbs = family === 'sport' && root.dataset.sportImage ? [root.dataset.sportImage] : view.thumbs;
    collectionImages.replaceChildren(...thumbs.map(url => photo(url, '')));
    collectionTitle.textContent = view.collection;
    collection.hidden = false;
    headerBenefits.hidden = false;
    introHeading.textContent = view.introHeading || '';
    introBody.textContent = view.introBody || '';
    intro.hidden = !view.introHeading;
    tagline.textContent = view.tagline;
    tagline.hidden = false;
    story.replaceChildren();
    renderStory(family, view);
    syncSummary();
  }

  function lineRole(line) {
    if (['merchandise', 'fee', 'membership'].includes(line.role)) return line.role;
    if (/^(?:Shipping|Delivery)(?:\s|$)/i.test(line.title)) return 'fee';
    if (/^(?:Calm Companion|Little Explorer Club|Daily Rhythm|App access)(?:\s|$)/i.test(line.title)) return 'membership';
    return 'merchandise';
  }

  function fallbackImage(family, variantTitle) {
    if (family === 'dog') {
      if (/blue/i.test(variantTitle)) return familyViews.dog.thumbs[1];
      if (/pink/i.test(variantTitle)) return familyViews.dog.thumbs[2];
      return familyViews.dog.thumbs[0];
    }
    if (family === 'sport') return '';
    return family === 'babyguard'
      ? files + 'files/babyguard-studio.png?v=1789586159&width=240'
      : files + 'files/cinnamon-studio.png?v=1789586179&width=240';
  }

  function renderSummary(session) {
    const rows = document.createDocumentFragment();
    const merchandise = session.lines.filter(line => lineRole(line) === 'merchandise');
    const shipping = session.lines.filter(line => lineRole(line) === 'fee');
    const feeInSubtotal = ['dog', 'babyguard', 'cinnamon'].includes(session.family);
    const visible = feeInSubtotal
      ? session.lines.filter(line => lineRole(line) === 'fee' || lineRole(line) === 'merchandise')
      : merchandise;
    if (session.family === 'sport') {
      const garment = merchandise.find(line => line.imageUrl);
      if (garment && /^https:\/\//.test(garment.imageUrl)) root.dataset.sportImage = garment.imageUrl;
    }
    for (const line of visible) {
      const row = document.createElement('div');
      row.className = 'lv-checkout__line';
      const imageBox = node('div', 'lv-checkout__line-image');
      const imageUrl = typeof line.imageUrl === 'string' && /^https:\/\//.test(line.imageUrl)
        ? line.imageUrl : lineRole(line) === 'fee' ? '' : fallbackImage(session.family, line.variantTitle || '');
      if (imageUrl) imageBox.append(photo(imageUrl, '', ''));
      else imageBox.classList.add('lv-checkout__line-image--fee');
      imageBox.append(node('span', 'lv-checkout__line-quantity', String(line.quantity)));
      const name = document.createElement('div');
      name.className = 'lv-checkout__line-name';
      const title = document.createElement('span');
      title.className = 'lv-checkout__line-title';
      title.textContent = line.title;
      const meta = document.createElement('span');
      meta.className = 'lv-checkout__line-meta';
      meta.textContent = line.variantTitle && line.variantTitle !== 'Default Title' ? line.variantTitle : '';
      const price = document.createElement('span');
      price.className = 'lv-checkout__line-price';
      price.textContent = money.format(line.lineCents / 100);
      name.append(title, meta);
      row.append(imageBox, name, price);
      rows.append(row);
    }
    linesNode.replaceChildren(rows);
    linesNode.setAttribute('aria-busy', 'false');
    subtotalNode.textContent = money.format((feeInSubtotal ? visible : merchandise).reduce((sum, line) => sum + line.lineCents, 0) / 100);
    shippingNode.textContent = feeInSubtotal ? 'Enter shipping address' : money.format(shipping.reduce((sum, line) => sum + line.lineCents, 0) / 100);
    totalNode.textContent = money.format(session.amountCents / 100);
    summaryToggleTotal.textContent = totalNode.textContent;
  }

  function renderCurrencyEstimate() {
    if (baseSession && baseSession.currency !== 'USD') {
      localEstimatePayment.hidden = true;
      localEstimateSummary.hidden = true;
      return;
    }
    // A source-store market estimate is already frozen in the checkout session.
    // Do not replace it with the Maostix store's visitor-location estimate.
    if (baseSession && verifiedMarketEstimate(baseSession)) return;
    const formatted = currencyHelper && currencyHelper.formatEstimate(
      estimateAmountCents, estimateCurrency, navigator.language, estimateRates,
    );
    if (!formatted) {
      localEstimatePayment.hidden = true;
      localEstimateSummary.hidden = true;
      return;
    }
    const reference = 'ECB reference rate for ' + estimateRates.date;
    localEstimatePayment.textContent = 'Approx. ' + formatted + ' ' + estimateCurrency +
      ' (' + reference + '). You will be charged ' + money.format(estimateAmountCents / 100) +
      ' USD. Your card issuer may use a different rate.';
    localEstimateSummary.textContent = 'Approx. ' + formatted + ' ' + estimateCurrency +
      ' (' + reference + '). Your card issuer’s rate may differ.';
    localEstimatePayment.hidden = false;
    localEstimateSummary.hidden = false;
  }

  async function getCurrencyRates(target) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 7000);
    try {
      const query = target === 'EUR' ? 'USD' : 'USD+' + target;
      const response = await fetch(
        'https://data-api.ecb.europa.eu/service/data/EXR/D.' + query +
          '.EUR.SP00.A?lastNObservations=1&format=jsondata',
        { mode: 'cors', credentials: 'omit', cache: 'default', signal: controller.signal },
      );
      if (!response.ok) return null;
      return currencyHelper.parseRates(await response.json(), target, Date.now());
    } finally {
      clearTimeout(timeout);
    }
  }

  function verifiedMarketEstimate(session) {
    const countries = { GBP: 'GB', CAD: 'CA', AUD: 'AU', NZD: 'NZ' };
    const locales = { GBP: 'en-GB', CAD: 'en-CA', AUD: 'en-AU', NZD: 'en-NZ' };
    const currency = session && session.displayCurrency;
    const amount = session && session.displayAmountCents;
    if (!session || session.currency !== 'USD' || !Object.prototype.hasOwnProperty.call(countries, currency) ||
        session.marketCountry !== countries[currency] || !Number.isInteger(amount) ||
        amount <= 0 || !Array.isArray(session.lines) ||
        !session.lines.every(line => Number.isInteger(line.displayLineCents) && line.displayLineCents >= 0) ||
        session.lines.reduce((sum, line) => sum + line.displayLineCents, 0) !== amount) return null;
    try {
      return {
        currency,
        formatted: new Intl.NumberFormat(locales[currency], {
          style: 'currency', currency, currencyDisplay: 'narrowSymbol',
        }).format(amount / 100),
      };
    } catch (_error) { return null; }
  }

  function updateCurrencyEstimate(session) {
    if (!localEstimatePayment || !localEstimateSummary) return;
    const market = verifiedMarketEstimate(session);
    if (market) {
      localEstimatePayment.textContent = 'Estimated total: ' + market.formatted + ' ' + market.currency +
        '. Charged in USD: ' + money.format(session.amountCents / 100) + ' USD.';
      localEstimateSummary.textContent = '≈ ' + market.formatted + ' ' + market.currency;
      localEstimatePayment.hidden = false;
      localEstimateSummary.hidden = false;
      return;
    }
    if (!currencyHelper) return;
    if (session.currency !== 'USD') {
      localEstimatePayment.hidden = true;
      localEstimateSummary.hidden = true;
      return;
    }
    estimateAmountCents = session.amountCents;
    const target = currencyHelper.pickCurrency(
      root.dataset.buyerCountry, root.dataset.buyerCurrency, navigator.language,
    );
    if (target !== estimateCurrency) {
      estimateCurrency = target;
      estimateRates = null;
      estimateRequestStarted = false;
    }
    renderCurrencyEstimate();
    if (target === 'USD' || estimateRequestStarted) return;
    estimateRequestStarted = true;
    getCurrencyRates(target).then(rates => {
      if (estimateCurrency === target) {
        estimateRates = rates;
        renderCurrencyEstimate();
      }
    }).catch(() => { /* Only the USD amount is shown if reference rates are unavailable. */ });
  }

  function validSession(session) {
    return session && typeof session === 'object' &&
      Number.isInteger(session.amountCents) && session.amountCents > 0 &&
      (session.currency === 'USD' ||
        (['GBP', 'CAD', 'AUD', 'NZD'].includes(session.currency) && session.chargeCurrencyVerified === true)) &&
      Number(session.productId) === productId &&
      (session.checkoutVersion === 1 || session.checkoutVersion === 2) &&
      ['dog', 'cinnamon', 'babyguard', 'sport'].includes(session.family) &&
      session.checkoutKind === (session.family === 'sport' ? 'one_time' : 'recurring') &&
      (session.family === 'sport'
        ? (session.returnPath === '/' || session.returnPath === sportReturnUrl) && session.returnHost === 'https://luvanosport.com'
        : returnPaths.has(session.returnPath)) &&
      Array.isArray(session.lines) && session.lines.length > 0 &&
      session.lines.every(line => line && typeof line.title === 'string' && line.title.length > 0 &&
        Number.isInteger(line.quantity) && line.quantity > 0 &&
        Number.isInteger(line.lineCents) && line.lineCents >= 0) &&
      session.lines.every(line => lineRole(line) !== 'membership' || line.lineCents === 0) &&
      session.lines.reduce((total, line) => total + line.lineCents, 0) === session.amountCents &&
      (session.displayCurrency === session.currency || Boolean(verifiedMarketEstimate(session)));
  }

  async function getSession() {
    const response = await fetch(apiBase + encodeURIComponent(sessionId), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('session');
    return response.json();
  }

  async function activateCheckout() {
    // The new host-owned form opts into the server's short reservation and
    // required customer lock. Older published checkout pages do not call this.
    const response = await fetch(apiBase + encodeURIComponent(sessionId) + '/activate', {
      method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('activation');
    const session = await response.json();
    if (session.status !== 'open' || session.checkoutVersion !== 2 || session.customerRequired !== true ||
        !Number.isFinite(Date.parse(session.expiresAt)) ||
        !Number.isFinite(Date.parse(session.serverNow))) throw new Error('activation');
    activationComplete = true;
    return session;
  }

  // These are existing Luvano product assets; the backend owns offer identity and price.
  const offerImages = {
    dog: {
      premium: files + 't/2/assets/luvano-dog-premium-pupperly-v1.gif?v=1790188524',
      downsell: files + 't/2/assets/luvano-dog-premium-pupperly-v1.gif?v=1790188524',
      digital: files + 'files/luvano-dog-collection-bundle.png?v=1789753459',
    },
    babyguard: {
      premium: files + 't/2/assets/luvano-premium-protection.jpg?v=1790098256',
      downsell: files + 't/2/assets/luvano-premium-protection.jpg?v=1790098256',
      digital: files + 'files/luvano-baby-collection-bundle.png?v=1789753467',
    },
    cinnamon: {
      premium: files + 't/2/assets/ceylon-reserve-30-v2.png?v=1790182084',
      downsell: files + 't/2/assets/ceylon-reserve-30-v2.png?v=1790182084',
      digital: files + 'files/luvano-wellness-collection-bundle.png?v=1789753474',
    },
    sport: {
      premium: files + 'files/premium-comfort-upgrade.jpg?v=1790545273',
      downsell: files + 'files/premium-comfort-upgrade.jpg?v=1790545273',
    },
  };
  const insuranceImage = files + 't/2/assets/luvano-shipping-insurance.png?v=1790098262';

  function originalPaysightSession() {
    try {
      const value = sessionStorage.getItem(originalPaymentKey);
      return typeof value === 'string' && value.length > 0 && value.length < 2048 ? value : '';
    } catch (_error) { return ''; }
  }

  function offerAmount(offer) {
    if (Number.isFinite(offer.amountMajor) && offer.amountMajor > 0) return offer.amountMajor;
    // Legacy USD contract only. Other currencies need a server-owned major-unit amount.
    if (offer.currency === 'USD' && Number.isInteger(offer.amountCents) && offer.amountCents > 0) {
      return offer.amountCents / 100;
    }
    return 0;
  }

  function validOffer(offer) {
    return offer && typeof offer.id === 'string' && /^[A-Za-z0-9_-]{1,80}$/.test(offer.id) &&
      offer.family === baseSession.family &&
      ['premium', 'downsell', 'digital', 'insurance'].includes(offer.step) &&
      typeof offer.title === 'string' && offer.title.length > 0 && offer.title.length < 180 &&
      offer.currency === baseSession.currency && offerAmount(offer) > 0;
  }

  function validChild(child) {
    return child && typeof child.sessionId === 'string' && /^[A-Za-z0-9_-]{10,50}$/.test(child.sessionId) &&
      typeof child.upsellId === 'string' && child.upsellId.length > 0 && child.upsellId.length <= 150 &&
      Number(child.productId) === productId && child.currency === baseSession.currency &&
      offerAmount(child) > 0;
  }

  function formatOfferPrice(offer) {
    try {
      return new Intl.NumberFormat(offer.currency === 'USD' ? 'en-US' : (navigator.language || 'en-US'), {
        // Active USD offer pages show dollar amounts regardless of browser locale.
        style: 'currency', currency: offer.currency,
      }).format(offerAmount(offer));
    } catch (_error) { return ''; }
  }

  function setOfferStatus(message, error) {
    offerStatus.textContent = message;
    offerStatus.classList.toggle('is-error', Boolean(error));
  }

  function renderOfferCountdown(expiresAt) {
    clearTimeout(offerCountdown);
    const deadline = typeof expiresAt === 'string' ? Date.parse(expiresAt) : NaN;
    if (!Number.isFinite(deadline)) {
      offerTimer.hidden = true;
      offerTimer.textContent = '';
      return false;
    }
    const tick = () => {
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const minutes = Math.floor(seconds / 60);
      offerTimer.textContent = 'Offer expires in: ' + String(minutes).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      offerTimer.hidden = false;
      if (seconds > 0) offerCountdown = setTimeout(tick, 1000);
      else {
        offerAccept.disabled = true;
        offerAcceptTop.disabled = true;
        offerAcceptSecondary.disabled = true;
        setOfferStatus('Checking offer availability…', false);
        schedulePoll(3000);
      }
    };
    tick();
    return deadline <= Date.now();
  }

  function renderOfferDetails(offer) {
    const premium = offer.step === 'premium' || offer.step === 'downsell';
    let eyebrow = 'Order confirmed';
    let headline = '';
    let subheading = '';
    let hook = '';
    let description = '';
    let inlineWarning = '';
    let guarantee = '';
    let warning = '';
    let details = [];
    if (offer.family === 'dog' && premium) {
      eyebrow = offer.step === 'premium' ? '⚠️ ONE-TIME OFFER' : '⚠️ WAIT! LAST CHANCE';
      headline = offer.step === 'premium' ? 'Your Order is Not Complete!' : 'Get Premium Comfort for even less';
      subheading = offer.step === 'premium' ? '[You only have Standard Version]' : '[One-time price, only on this page]';
      hook = offer.step === 'premium'
        ? 'Upgrade your Cozy Crescent Pillow and add premium comfort for every nap!' : '';
      description = offer.step === 'premium'
        ? 'Add premium fabric + upgraded filling for extra comfort during every nap!' : '';
      details = ['Premium fabric + upgraded filling', 'Applies to every pillow in this order'];
      guarantee = '100% Money Back Guarantee';
      warning = offer.step === 'premium'
        ? '⚠️ WARNING! ⚠️ This offer is only available during this checkout session. ONE-TIME OFFER!' : '';
    } else if (offer.family === 'dog' && offer.step === 'digital') {
      eyebrow = '🚨 STOP 🚨';
      headline = "You've Unlocked Our Special Welcome Offer 🎁";
      description = 'Three digital PDFs, delivered to your inbox after payment.';
      inlineWarning = '⚠️ WARNING! ⚠️ This offer is only available during this checkout session. ONE-TIME OFFER!';
    } else if (offer.family === 'cinnamon' && premium) {
      eyebrow = offer.step === 'premium' ? '⚠️ ONE-TIME OFFER' : '⚠️ WAIT! LAST CHANCE';
      headline = offer.step === 'premium' ? 'Your Order is Not Complete!' : 'Get Ceylon Reserve for even less';
      subheading = offer.step === 'premium' ? '[You only have Standard Version]' : '[One-time price, only on this page]';
      hook = offer.step === 'premium'
        ? 'Upgrade your Ceylon Cinnamon + MCT Oil to our enhanced Ceylon Reserve formula!' : '';
      description = offer.step === 'premium'
        ? 'Upgrade to Ceylon cinnamon + MCT oil with added chromium in our enhanced formula — still 30 softgels!' : '';
      details = ['Enhanced formula with added chromium', '30 softgels per pouch', 'Applies to every cinnamon pack in this order'];
      guarantee = '100% Money Back Guarantee';
      warning = offer.step === 'premium'
        ? '⚠️ WARNING! ⚠️ This offer is only available during this checkout session. ONE-TIME OFFER!' : '';
    } else if (offer.family === 'cinnamon' && offer.step === 'digital') {
      eyebrow = '🚨 STOP 🚨';
      headline = "You've Unlocked Our Special Welcome Offer 🎁";
      description = "You've unlocked our special The Daily Rhythm Collection!";
      inlineWarning = '⚠️ WARNING! ⚠️ This offer is only available during this checkout session. ONE-TIME OFFER!';
      details = [
        'Three digital PDFs - included in your collection',
        '📧 Your private download is emailed after payment',
      ];
    } else if (offer.family === 'babyguard' && premium) {
      eyebrow = offer.step === 'premium' ? '⚠️ ONE-TIME OFFER' : '⚠️ WAIT! LAST CHANCE';
      headline = offer.step === 'premium'
        ? 'Your Order is Not Complete!' : 'Get Premium Protection for even less';
      subheading = offer.step === 'premium'
        ? '[You only have Standard Version]' : '[One-time price, only on this page]';
      hook = offer.step === 'premium'
        ? 'Upgrade your Little Explorer Pillow and add Premium Protection for every wobble, bump and tumble!' : '';
      description = offer.step === 'premium'
        ? 'Add thicker plush padding + a fuller cushioned body for deeper protection and softer, safer landings!' : '';
      details = offer.step === 'downsell'
        ? ['Thicker plush padding + fuller cushioned body', 'Applies to every pillow in this order'] : [];
      guarantee = '100% Money Back Guarantee';
      warning = offer.step === 'premium'
        ? '⚠️ WARNING! ⚠️ If you leave this page... ONE TIME 50% OFF DISCOUNT!' : '';
    } else if (offer.family === 'babyguard' && offer.step === 'digital') {
      eyebrow = '🚨 STOP 🚨';
      headline = 'Your Special Welcome Offer 🎁';
      description = 'Three digital PDFs, delivered to your inbox after payment.';
      inlineWarning = '⚠️ WARNING! ⚠️ This offer is only available during this checkout session. ONE-TIME OFFER!';
    } else if (offer.family === 'babyguard' && offer.step === 'insurance') {
      eyebrow = '🚨 WAIT 🚨';
      headline = 'Ensure your package arrives safely!';
      description = 'Protect your order from Damage, Loss & Theft during shipping. (for only $9.99)';
    } else if (offer.family === 'sport' && premium) {
      eyebrow = '⚠️ ONE-TIME OFFER';
      headline = 'Your Order is Not Complete!';
      subheading = '[You only have Standard Version]';
      hook = offer.step === 'premium'
        ? 'Upgrade your 3D pieces and add Premium Comfort to every piece in your order!' : '';
      description = offer.step === 'premium'
        ? 'Add soft-touch inner knit + smoother edge finishing for a softer feel!'
        : 'Soft-touch inner knit + smoother edge finishing. Premium Comfort for every 3D piece in your order.';
      guarantee = '100% Money Back Guarantee';
      warning = offer.step === 'premium'
        ? '⚠️ WARNING! ⚠️ If you leave this page, you will never be able to take advantage of this offer ever again! ONE TIME 50% OFF DISCOUNT!' : '';
    }
    offerEyebrow.textContent = eyebrow;
    offerHeadline.textContent = headline;
    offerHeadline.hidden = !headline;
    offerSubheading.textContent = subheading;
    offerSubheading.hidden = !subheading;
    offerHook.textContent = hook;
    offerHook.hidden = !hook;
    offerDescription.textContent = description;
    if (offer.family === 'babyguard' && offer.step === 'premium') {
      offerDescription.replaceChildren(
        document.createTextNode('Add '),
        node('span', 'lv-checkout__offer-green', 'thicker plush padding'),
        document.createTextNode(' + '),
        node('span', 'lv-checkout__offer-green', 'a fuller cushioned body'),
        document.createTextNode(' for deeper protection and '),
        node('span', 'lv-checkout__offer-red', 'softer, safer landings!'),
      );
    } else if (offer.family === 'dog' && offer.step === 'premium') {
      offerDescription.replaceChildren(
        document.createTextNode('Add '),
        node('span', 'lv-checkout__offer-green', 'premium fabric + upgraded filling'),
        document.createTextNode(' for '),
        node('span', 'lv-checkout__offer-red', 'extra comfort during every nap!'),
      );
    } else if (offer.family === 'cinnamon' && offer.step === 'premium') {
      offerDescription.replaceChildren(
        document.createTextNode('Upgrade to '),
        node('span', 'lv-checkout__offer-green', 'Ceylon cinnamon + MCT oil with added chromium'),
        document.createTextNode(' in our '),
        node('span', 'lv-checkout__offer-red', 'enhanced formula — still 30 softgels!'),
      );
    } else if (offer.family === 'sport' && offer.step === 'premium') {
      offerDescription.replaceChildren(
        document.createTextNode('Add '),
        node('span', 'lv-checkout__offer-green', 'soft-touch inner knit + smoother edge finishing'),
        document.createTextNode(' for a softer feel!'),
      );
    }
    offerDescription.hidden = !description;
    offerInlineWarning.textContent = inlineWarning;
    offerInlineWarning.hidden = !inlineWarning;
    offerGuarantee.textContent = guarantee;
    offerGuarantee.hidden = !guarantee;
    offerWarningLead.textContent = warning ? '⚠️ WARNING! ⚠️' : '';
    offerWarningBody.textContent = warning && offer.family === 'sport'
      ? 'If you leave this page...'
      : warning && offer.family === 'babyguard'
        ? 'If you leave this page, you will never be able to take advantage of this offer ever again!'
      : warning ? 'This offer is only available during this checkout session.' : '';
    offerWarningEmphasis.textContent = warning && ['babyguard', 'sport'].includes(offer.family)
      ? 'ONE TIME 50% OFF DISCOUNT!' : warning ? 'ONE-TIME OFFER!' : '';
    offerWarning.hidden = !warning;
    // A countdown appears only for a deadline that the server also enforces.
    const list = node('ul');
    details.forEach(detail => list.append(node('li', '', detail)));
    offerBenefits.replaceChildren(list);
    offerBenefits.hidden = details.length === 0;
    const ratingLabel = offer.family === 'babyguard'
      ? (offer.step === 'insurance' ? '99% Satisfaction rate' : '5.0 Bestseller')
      : (offer.family === 'sport' && premium ? '5.0 Bestseller' : '');
    offerRatingLabel.textContent = ratingLabel;
    offerRating.hidden = !ratingLabel;
    offerCompare.textContent = offer.currency === 'USD' &&
      ((offer.family === 'babyguard' && premium) || (offer.family === 'sport' && offer.step === 'premium'))
      ? '$49.99' : offer.family === 'babyguard' && offer.step === 'insurance' && offer.currency === 'USD'
        ? '$19.99' : offer.family === 'sport' && offer.step === 'downsell' && offer.currency === 'USD'
          ? '$29.99' : '';
    offerCompare.hidden = !offerCompare.textContent;
    offerSavings.textContent = offer.currency === 'USD' && premium && offer.family === 'sport'
      ? (offer.step === 'premium' ? '($25 Savings)' : '($15 Savings)') :
      offer.currency === 'USD' && premium && offer.family === 'babyguard'
        ? (offer.step === 'premium' ? '($25 Savings)' : '(Save $35)') :
        offer.currency === 'USD' && offer.family === 'babyguard' && offer.step === 'insurance'
          ? '(Save $10)' : '';
    offerSavings.hidden = !offerSavings.textContent;
    offerOption.hidden = true;
  }

  function showOffer(offer, processing) {
    const firstView = offerCard.hidden;
    currentOffer = offer;
    setOfferPresentation(true, offer.step);
    paymentCard.hidden = true;
    result.hidden = true;
    returnLink.hidden = true;
    offerCard.hidden = false;
    renderOfferDetails(offer);
    const imageUrl = offer.step === 'insurance' ? insuranceImage :
      offerImages[offer.family] && offerImages[offer.family][offer.step];
    offerImage.hidden = !imageUrl;
    if (imageUrl) {
      offerImage.src = imageUrl;
      offerImage.alt = offer.family === 'babyguard' && ['premium', 'downsell'].includes(offer.step)
        ? 'Standard and Premium Little Explorer Pillow comparison' :
          offer.family === 'sport' && ['premium', 'downsell'].includes(offer.step)
            ? 'Standard and Premium Comfort knit comparison' :
            offer.family === 'dog' && ['premium', 'downsell'].includes(offer.step)
              ? 'Upgrade Your Cozy Crescent Pillow' :
              offer.family === 'dog' && offer.step === 'digital'
                ? 'Luvano — The Calm Dog Collection' :
              offer.family === 'cinnamon' && ['premium', 'downsell'].includes(offer.step)
                ? 'Upgrade to Ceylon Reserve' : offer.title;
    }
    offerTitle.textContent = offer.family === 'sport' && ['premium', 'downsell'].includes(offer.step)
      ? 'Upgrade To Premium Comfort [All 3D Pieces]' :
        offer.family === 'dog' && ['premium', 'downsell'].includes(offer.step)
          ? 'Upgrade To Premium Comfort [All Pillows]' :
          offer.family === 'cinnamon' && ['premium', 'downsell'].includes(offer.step)
            ? 'Upgrade To Ceylon Reserve [All Packs]' : offer.title;
    const price = formatOfferPrice(offer);
    offerPrice.textContent = price;
    offerAccept.textContent = upsellError ? 'Try payment again' :
      offer.family === 'sport' ? 'Complete My Order!' :
        offer.family === 'babyguard' && offer.step === 'premium' ? 'Yes, Add Premium Protection for ' + price :
          offer.family === 'babyguard' && offer.step === 'downsell' ? 'Yes, Upgrade My Order for ' + price :
            'Yes, accept this offer · ' + price;
    const widePremium = ['dog', 'cinnamon', 'sport'].includes(offer.family) && offer.step === 'premium';
    const wideDownsell = ['dog', 'cinnamon', 'sport'].includes(offer.family) && offer.step === 'downsell';
    const cinnamonDigital = offer.family === 'cinnamon' && offer.step === 'digital';
    const collectionDigital = ['dog', 'babyguard'].includes(offer.family) && offer.step === 'digital';
    const babyPremium = offer.family === 'babyguard' && offer.step === 'premium';
    const babyDownsell = offer.family === 'babyguard' && offer.step === 'downsell';
    const babyInsurance = offer.family === 'babyguard' && offer.step === 'insurance';
    offerAcceptTop.textContent = upsellError ? 'Try payment again' :
      widePremium || offer.family === 'sport' && offer.step === 'downsell' ? 'Complete My Order!' : wideDownsell ? 'Yes, Upgrade My Order for ' + price :
        cinnamonDigital ? 'Yes, Complete My Order!' :
          collectionDigital ? 'Yes, Add ' + offer.title + ' for ' + price :
          babyPremium ? 'Yes, Add Premium Protection for ' + price :
            babyDownsell ? 'Yes, Upgrade My Order for ' + price :
              babyInsurance ? 'Yes, Add Shipping Insurance for ' + price : '';
    offerAcceptTop.hidden = !(widePremium || wideDownsell || cinnamonDigital || collectionDigital || babyPremium || babyDownsell || babyInsurance) ||
      (processing && !upsellError);
    offerDecline.textContent = widePremium || wideDownsell || cinnamonDigital || collectionDigital || babyPremium || babyDownsell || babyInsurance
      ? 'No thanks, complete my order' : 'No thanks, continue';
    offerAcceptSecondary.textContent = widePremium ? 'Complete Your Order!' :
      cinnamonDigital ? 'Yes, Complete My Order!' :
        collectionDigital ? 'Yes, Add ' + offer.title + ' for ' + price :
        babyPremium ? 'Yes, Upgrade My Order for ' + price : offerAccept.textContent;
    offerAcceptSecondary.hidden = !(widePremium || cinnamonDigital || collectionDigital || babyPremium) ||
      (processing && !upsellError);
    offerAccept.hidden = widePremium || wideDownsell || cinnamonDigital || collectionDigital || babyPremium || babyDownsell || babyInsurance ||
      (processing && !upsellError);
    offerDecline.hidden = processing;
    offerAccept.disabled = upsellBusy || upsellSubmitting;
    offerAcceptTop.disabled = upsellBusy || upsellSubmitting;
    offerAcceptSecondary.disabled = upsellBusy || upsellSubmitting;
    offerDecline.disabled = upsellBusy || upsellSubmitting;
    setOfferStatus(processing ? (upsellError ? copy.offerError : copy.offerProcessing) : '', upsellError);
    status('', false);
    if (firstView) offerTitle.focus({ preventScroll: true });
  }

  async function getUpsellState() {
    const response = await fetch(apiBase + encodeURIComponent(sessionId) + '/upsell', {
      method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('upsell-state');
    return response.json();
  }

  async function postUpsellAction(offerId, action, body) {
    const response = await fetch(apiBase + encodeURIComponent(sessionId) +
      '/upsell/' + encodeURIComponent(offerId) + '/' + action, {
      method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    });
    if (!response.ok) throw new Error('upsell-' + action);
    return response.json();
  }

  function notifyUpsell(offerId, payload) {
    const transactionId = payload && payload.transactionId;
    if (typeof transactionId !== 'string' || !transactionId || transactionId.length > 200) return;
    const body = { transactionId };
    if (Number.isSafeInteger(payload.orderId) && payload.orderId > 0) body.orderId = payload.orderId;
    postUpsellAction(offerId, 'notify', body).catch(() => {});
  }

  function handleUpsellMessage(message) {
    if (!currentOffer) return;
    switch (message && message.type) {
      case 'PAYMENT_START':
        setOfferStatus(copy.offerProcessing, false);
        break;
      case 'PAYMENT_SUCCESS':
      case 'DUPLICATE_TRANSACTION':
        upsellSubmitting = false;
        upsellError = false;
        if (message.payload) notifyUpsell(currentOffer.id, message.payload);
        showOffer(currentOffer, true);
        schedulePoll(500);
        break;
      case 'PAYMENT_ERROR':
      case 'PAYMENT_3DS_ERROR':
      case 'PAYMENT_3DS_FAILURE':
      case 'ERROR':
        upsellSubmitting = false;
        upsellError = true;
        upsellSubmitIssued = false;
        showOffer(currentOffer, true);
        schedulePoll(10000);
        break;
      default:
        break;
    }
  }

  let upsellSubmitIssued = false;
  let upsellWidgetReady = false;
  function submitCurrentUpsell() {
    if (!upsellSubmitting || upsellSubmitIssued || !upsellWidgetReady ||
        !upsellWidget || typeof upsellWidget.submitUpsell !== 'function') return;
    upsellSubmitIssued = true;
    try {
      Promise.resolve(upsellWidget.submitUpsell()).catch(() => {
        upsellSubmitting = false;
        upsellError = true;
        upsellSubmitIssued = false;
        if (currentOffer) showOffer(currentOffer, true);
      });
    } catch (_error) {
      upsellSubmitting = false;
      upsellError = true;
      upsellSubmitIssued = false;
      if (currentOffer) showOffer(currentOffer, true);
    }
  }

  async function mountUpsellWidget(child) {
    if (upsellWidget && upsellWidgetSessionId === child.sessionId) {
      submitCurrentUpsell();
      return;
    }
    await loadSdk();
    if (upsellWidget && typeof upsellWidget.destroy === 'function') upsellWidget.destroy();
    offerWidgetTarget.replaceChildren();
    upsellWidgetReady = false;
    upsellSubmitIssued = false;
    upsellWidgetSessionId = child.sessionId;
    upsellWidget = window.PaySightSDK.createWidget({
      targetId: 'luvano-upsell-widget',
      config: {
        productId,
        sessionId: child.sessionId,
        environment: 'production',
        amount: offerAmount(child),
        currency: child.currency,
        locale: 'en-US',
        ecom: true,
        singlePurchase: true,
        usePreviousPaymentMethod: true,
        hidePaymentButton: true,
        upsell: {
          upsellId: child.upsellId,
          initialPaymentSession: originalPaysightSession(),
        },
      },
      onReady: () => {
        upsellWidgetReady = true;
        Promise.resolve().then(submitCurrentUpsell);
      },
      onMessage: handleUpsellMessage,
    });
    submitCurrentUpsell();
  }

  async function acceptOffer() {
    if (!currentOffer || upsellBusy || upsellSubmitting || !originalPaysightSession()) return;
    upsellBusy = true;
    offerAccept.disabled = true;
    offerAcceptTop.disabled = true;
    offerAcceptSecondary.disabled = true;
    offerDecline.disabled = true;
    try {
      let child = currentChild;
      if (!child) {
        const state = await postUpsellAction(currentOffer.id, 'accept');
        if (state.status !== 'processing' || !validChild(state.child)) throw new Error('upsell-intent');
        child = state.child;
        currentChild = child;
      }
      upsellError = false;
      upsellSubmitting = true;
      showOffer(currentOffer, true);
      renderOfferCountdown(null);
      await mountUpsellWidget(child);
      schedulePoll(3000);
    } catch (_error) {
      upsellSubmitting = false;
      upsellError = Boolean(currentChild);
      if (currentChild) showOffer(currentOffer, true);
      else {
        showOffer(currentOffer, false);
        setOfferStatus(copy.offerError, true);
      }
    } finally {
      upsellBusy = false;
      offerAccept.disabled = upsellSubmitting;
      offerAcceptTop.disabled = upsellSubmitting;
      offerAcceptSecondary.disabled = upsellSubmitting;
      offerDecline.disabled = upsellSubmitting;
    }
  }

  async function declineOffer() {
    if (!currentOffer || currentChild || upsellBusy || upsellSubmitting) return;
    upsellBusy = true;
    offerAccept.disabled = true;
    offerAcceptTop.disabled = true;
    offerAcceptSecondary.disabled = true;
    offerDecline.disabled = true;
    try {
      const state = await postUpsellAction(currentOffer.id, 'decline');
      await applyUpsellState(state);
    } catch (_error) {
      setOfferStatus(copy.paysightUnavailable, true);
    } finally {
      upsellBusy = false;
      offerAccept.disabled = false;
      offerAcceptTop.disabled = false;
      offerAcceptSecondary.disabled = false;
      offerDecline.disabled = false;
    }
  }

  async function applyUpsellState(state) {
    if (!state || typeof state.status !== 'string') throw new Error('upsell-state');
    if (state.status === 'disabled' || state.status === 'complete') {
      currentOffer = null;
      currentChild = null;
      showResult(copy.successHeading, copy.successBody, false);
      return;
    }
    if (state.status === 'waiting_for_initial') {
      showProcessing(false);
      schedulePoll(3000);
      return;
    }
    if (state.status === 'review') {
      showReview(true);
      schedulePoll(15000);
      return;
    }
    if ((state.status === 'offered' || state.status === 'processing') &&
        validOffer(state.offer) && originalPaysightSession()) {
      if (!currentOffer || currentOffer.id !== state.offer.id) {
        if (upsellWidget && typeof upsellWidget.destroy === 'function') upsellWidget.destroy();
        offerWidgetTarget.replaceChildren();
        currentChild = null;
        upsellError = false;
        upsellSubmitting = false;
        upsellWidget = null;
        upsellWidgetSessionId = '';
        upsellWidgetReady = false;
      }
      if (state.status === 'offered') currentChild = null;
      if (state.status === 'processing' && validChild(state.child)) currentChild = state.child;
      showOffer(state.offer, state.status === 'processing');
      const expired = renderOfferCountdown(state.status === 'offered' ? state.offerExpiresAt : null);
      schedulePoll(state.status === 'processing' || expired ? 3000 : 20000);
      return;
    }
    // A missing saved provider session cannot produce a one-click charge.
    showResult(copy.successHeading, copy.successBody, false);
  }

  offerAccept.addEventListener('click', acceptOffer);
  offerAcceptTop.addEventListener('click', acceptOffer);
  offerAcceptSecondary.addEventListener('click', acceptOffer);
  offerDecline.addEventListener('click', declineOffer);

  function loadSdk() {
    if (window.PaySightSDK && typeof window.PaySightSDK.createWidget === 'function') return Promise.resolve();
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = setTimeout(() => reject(new Error('sdk-timeout')), 15000);
      script.src = sdkUrl;
      script.async = true;
      script.onload = () => {
        clearTimeout(timeout);
        window.PaySightSDK && typeof window.PaySightSDK.createWidget === 'function' ? resolve() : reject(new Error('sdk'));
      };
      script.onerror = () => { clearTimeout(timeout); reject(new Error('sdk')); };
      document.head.appendChild(script);
    });
    return sdkPromise;
  }

  function schedulePoll(delay) {
    clearTimeout(timer);
    timer = setTimeout(() => { refresh().catch(() => {
      if (reviewing) {
        schedulePoll(20000);
      } else if (paymentSignaled) {
        showProcessing(true);
        schedulePoll(10000);
      } else {
        status(copy.paysightUnavailable, true);
        schedulePoll(20000);
      }
    }); }, delay);
  }

  function notifyPayment(payload) {
    const transactionId = payload && payload.transactionId;
    if (typeof transactionId !== 'string' || !transactionId || transactionId.length > 200) return;
    const body = { transactionId };
    if (Number.isSafeInteger(payload.orderId) && payload.orderId > 0) body.orderId = payload.orderId;
    // A browser event only wakes server reconciliation; it never confirms an order.
    fetch(apiBase + encodeURIComponent(sessionId) + '/notify', {
      method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => {});
  }

  const shippingMarketCountry = { USD: 'US', GBP: 'GB', CAD: 'CA', AUD: 'AU', NZD: 'NZ' };
  const dialPrefixByCountry = { US: '+1', GB: '+44', CA: '+1', AU: '+61', NZ: '+64' };
  const shippingRegions = {
    US: 'AL:Alabama|AK:Alaska|AZ:Arizona|AR:Arkansas|CA:California|CO:Colorado|CT:Connecticut|DE:Delaware|DC:District of Columbia|FL:Florida|GA:Georgia|HI:Hawaii|ID:Idaho|IL:Illinois|IN:Indiana|IA:Iowa|KS:Kansas|KY:Kentucky|LA:Louisiana|ME:Maine|MD:Maryland|MA:Massachusetts|MI:Michigan|MN:Minnesota|MS:Mississippi|MO:Missouri|MT:Montana|NE:Nebraska|NV:Nevada|NH:New Hampshire|NJ:New Jersey|NM:New Mexico|NY:New York|NC:North Carolina|ND:North Dakota|OH:Ohio|OK:Oklahoma|OR:Oregon|PA:Pennsylvania|RI:Rhode Island|SC:South Carolina|SD:South Dakota|TN:Tennessee|TX:Texas|UT:Utah|VT:Vermont|VA:Virginia|WA:Washington|WV:West Virginia|WI:Wisconsin|WY:Wyoming',
    CA: 'AB:Alberta|BC:British Columbia|MB:Manitoba|NB:New Brunswick|NL:Newfoundland and Labrador|NT:Northwest Territories|NS:Nova Scotia|NU:Nunavut|ON:Ontario|PE:Prince Edward Island|QC:Quebec|SK:Saskatchewan|YT:Yukon',
    AU: 'ACT:Australian Capital Territory|NSW:New South Wales|NT:Northern Territory|QLD:Queensland|SA:South Australia|TAS:Tasmania|VIC:Victoria|WA:Western Australia',
  };

  function syncShippingRegion(country) {
    const entries = shippingRegions[country];
    const hasSelector = Boolean(entries);
    shippingProvinceInput.hidden = hasSelector;
    shippingProvinceInput.required = false;
    shippingProvinceSelect.hidden = !hasSelector;
    shippingProvinceSelect.required = hasSelector;
    if (hasSelector) {
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select';
      const options = entries.split('|').map(entry => {
        const [code, label] = entry.split(':');
        const option = document.createElement('option');
        option.value = code;
        option.textContent = label;
        return option;
      });
      shippingProvinceSelect.replaceChildren(placeholder, ...options);
      shippingProvinceSelect.value = '';
    }
    phonePrefixSelect.value = dialPrefixByCountry[country] || '+1';
  }

  function formValue(name) {
    if (name === 'province' && !shippingProvinceSelect.hidden) return String(shippingProvinceSelect.value || '').trim();
    return String(root.querySelector('[name="' + name + '"]')?.value || '').trim();
  }

  function phoneFromForm() {
    const phone = formValue('phone');
    if (!phone || phone.startsWith('+')) return phone;
    const prefix = formValue('phonePrefix') || dialPrefixByCountry[shippingCountryInput.value] || '';
    const national = ['+44', '+61', '+64'].includes(prefix) ? phone.replace(/^0+/, '') : phone;
    return prefix + national;
  }

  function syncBillingFields() {
    const separate = !billingSameInput.checked;
    billingFields.hidden = !separate;
    for (const name of ['billingFirstName', 'billingLastName', 'billingAddress1', 'billingCity', 'billingZip', 'billingCountryCode']) {
      root.querySelector('[name="' + name + '"]').required = separate;
    }
    const country = formValue('billingCountryCode');
    root.querySelector('[name="billingProvince"]').required = separate && ['US', 'CA', 'AU'].includes(country);
  }

  billingSameInput.addEventListener('change', syncBillingFields);
  root.querySelector('[name="billingCountryCode"]').addEventListener('change', syncBillingFields);

  function addressFromForm(prefix) {
    return {
      firstName: formValue(prefix + 'FirstName'), lastName: formValue(prefix + 'LastName'),
      address1: formValue(prefix + 'Address1'), address2: formValue(prefix + 'Address2'),
      company: formValue(prefix + 'Company'), city: formValue(prefix + 'City'),
      province: formValue(prefix + 'Province'), zip: formValue(prefix + 'Zip'),
      countryCode: formValue(prefix + 'CountryCode'),
    };
  }

  function shippingAddressFromForm() {
    return {
      firstName: formValue('firstName'), lastName: formValue('lastName'),
      address1: formValue('address1'), address2: formValue('address2'),
      company: formValue('company'), city: formValue('city'),
      province: formValue('province'), zip: formValue('zip'),
      countryCode: shippingCountryInput.value,
    };
  }

  function syncShippingMessage() {
    if (!baseSession || baseSession.status !== 'open') return;
    const required = ['firstName', 'lastName', 'address1', 'city', 'zip'];
    if (['US', 'CA', 'AU'].includes(shippingCountryInput.value)) required.push('province');
    const filled = required.every(name => formValue(name)) && Boolean(shippingCountryInput.value);
    shippingMethodMessage.textContent = filled
      ? 'Shipping is included in the order total shown.' : 'Enter your shipping address to view available shipping methods';
    if (['dog', 'babyguard', 'cinnamon'].includes(baseSession.family)) {
      shippingNode.textContent = filled ? 'Included in total' : 'Enter shipping address';
    }
  }

  customerForm.addEventListener('input', syncShippingMessage);
  shippingProvinceSelect.addEventListener('change', syncShippingMessage);

  async function saveCustomer(customer) {
    const response = await fetch(apiBase + encodeURIComponent(sessionId) + '/customer', {
      method: 'PUT', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(customer),
    });
    if (!response.ok) throw new Error('customer-save');
  }

  async function verifyLockedCustomer(customer) {
    const response = await fetch(apiBase + encodeURIComponent(sessionId) + '/customer/verify', {
      method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(customer),
    });
    if (!response.ok) throw new Error('customer-verify');
  }

  async function lockCustomer() {
    const response = await fetch(apiBase + encodeURIComponent(sessionId) + '/customer/lock', {
      method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: '{}',
    });
    if (!response.ok) throw new Error('customer-lock');
    customerLocked = true;
  }

  function syncCustomerRetryNote() {
    customerRetryNote.hidden = !customerLocked || paymentSubmitting;
  }

  function updateWidgetCustomer(customer) {
    if (!widgetReady || !widget || typeof widget.update !== 'function') {
      return Promise.reject(new Error('widget-not-ready'));
    }
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        if (configUpdateWaiter?.reject === fail) fail(new Error('widget-update-timeout'));
      }, 10000);
      const finish = () => { clearTimeout(timeout); configUpdateWaiter = null; resolve(); };
      const fail = error => { clearTimeout(timeout); configUpdateWaiter = null; reject(error); };
      configUpdateWaiter = { resolve: finish, reject: fail };
      try {
        Promise.resolve(widget.update({ customer })).catch(fail);
      } catch (error) { fail(error); }
    });
  }

  async function submitInitialPayment(event) {
    event.preventDefault();
    if (!baseSession || baseSession.status !== 'open' || paymentSubmitting || paymentSignaled || !widgetReady) return;
    if (Number.isFinite(reservationDeadline) && Date.now() + serverClockOffsetMs >= reservationDeadline) {
      paymentSubmit.disabled = true;
      refresh().catch(() => showResult(copy.unavailable, '', returnButton.dataset.hasProduct === 'true'));
      return;
    }
    syncBillingFields();
    if (typeof customerForm.reportValidity === 'function' && !customerForm.reportValidity()) return;
    const shipping = shippingAddressFromForm();
    const country = shippingMarketCountry[verifiedMarketEstimate(baseSession)?.currency || baseSession.currency];
    if (!country || shipping.countryCode !== country) {
      status('Shipping country does not match this checkout. Please return to the product page.', true);
      return;
    }
    const billingSameAsShipping = billingSameInput.checked;
    const customer = {
      email: formValue('email'), phone: phoneFromForm(), shipping, billingSameAsShipping,
      ...(!billingSameAsShipping ? { billing: addressFromForm('billing') } : {}),
    };
    const paymentAddress = billingSameAsShipping ? shipping : customer.billing;
    paymentSubmitting = true;
    syncCustomerRetryNote();
    paymentSubmit.disabled = true;
    status('Saving your details…', false);
    try {
      if (customerLocked) await verifyLockedCustomer(customer);
      else await saveCustomer(customer);
      await updateWidgetCustomer({
        email: customer.email, phone: customer.phone,
        firstName: paymentAddress.firstName, lastName: paymentAddress.lastName,
        address: paymentAddress.address1, city: paymentAddress.city, state: paymentAddress.province,
        zip: paymentAddress.zip, country: paymentAddress.countryCode,
      });
      if (!customerLocked) await lockCustomer();
      if (!widget || typeof widget.submitPayment !== 'function') throw new Error('widget-submit-unavailable');
      try { sessionStorage.setItem(paymentStartedKey, String(Date.now())); } catch (_error) { /* storage may be disabled */ }
      status(copy.processing, false);
      await Promise.resolve(widget.submitPayment());
    } catch (error) {
      try { sessionStorage.removeItem(paymentStartedKey); } catch (_error) { /* storage may be disabled */ }
      paymentSubmitting = false;
      syncCustomerRetryNote();
      const expired = Number.isFinite(reservationDeadline) && Date.now() + serverClockOffsetMs >= reservationDeadline;
      paymentSubmit.disabled = expired;
      if (expired) {
        refresh().catch(() => showResult(copy.unavailable, '', returnButton.dataset.hasProduct === 'true'));
        return;
      }
      status(error && error.message === 'customer-verify'
        ? 'These details do not match the saved checkout. Enter the same delivery and billing details to retry.'
        : 'We could not submit this checkout. Please review your details and try again.', true);
    }
  }

  customerForm.addEventListener('submit', submitInitialPayment);

  function handleMessage(message) {
    switch (message && message.type) {
      case 'CONFIG_UPDATE_SUCCESS':
        configUpdateWaiter?.resolve();
        break;
      case 'CONFIG_UPDATE_ERROR':
      case 'CONFIG_UPDATE_FAILURE':
        configUpdateWaiter?.reject(new Error('widget-update'));
        break;
      case 'PAYMENT_START':
        paymentSubmit.disabled = true;
        status(copy.processing, false);
        break;
      case 'PAYMENT_SUCCESS':
        paymentSignaled = true;
        paymentStartedRecovered = false;
        try { sessionStorage.removeItem(paymentStartedKey); } catch (_error) { /* storage may be disabled */ }
        try { sessionStorage.setItem(pendingKey, '1'); } catch (_error) { /* storage may be disabled */ }
        if (typeof message.payload?.paysightSession === 'string' &&
            message.payload.paysightSession.length > 0 && message.payload.paysightSession.length < 2048) {
          try { sessionStorage.setItem(originalPaymentKey, message.payload.paysightSession); }
          catch (_error) { /* storage may be disabled; the paid base order still completes */ }
        }
        notifyPayment(message.payload);
        showProcessing(false);
        schedulePoll(500);
        break;
      case 'PAYMENT_ERROR':
      case 'ERROR':
      case 'PAYMENT_3DS_ERROR':
      case 'PAYMENT_3DS_FAILURE':
        try { sessionStorage.removeItem(paymentStartedKey); } catch (_error) { /* storage may be disabled */ }
        paymentSubmitting = false;
        syncCustomerRetryNote();
        if (Number.isFinite(reservationDeadline) && Date.now() + serverClockOffsetMs >= reservationDeadline) {
          paymentSubmit.disabled = true;
          refresh().catch(() => showResult(copy.unavailable, '', returnButton.dataset.hasProduct === 'true'));
        } else {
          paymentSubmit.disabled = false;
          status(copy.errorRetry, true);
        }
        break;
      default:
        break;
    }
  }

  async function mountWidget(session) {
    if (widget || paymentSignaled) return;
    await loadSdk();
    paymentCard.hidden = false;
    result.hidden = true;
    widgetReady = false;
    paymentSubmit.disabled = true;
    shippingCountryInput.value = shippingMarketCountry[verifiedMarketEstimate(session)?.currency || session.currency] || '';
    syncShippingRegion(shippingCountryInput.value);
    syncBillingFields();
    widget = window.PaySightSDK.createWidget({
      targetId: 'luvano-payment-widget',
      config: {
        productId,
        sessionId,
        environment: 'production',
        amount: session.amountCents / 100,
        currency: session.currency,
        locale: 'en-US',
        ecom: true,
        savePaymentMethod: true,
        ...(session.family === 'sport' && session.checkoutKind === 'one_time' ? { singlePurchase: true } : {}),
        hidePaymentButton: true,
        fields: [],
        paymentSuccess: { title: copy.processing, description: copy.verificationDelayed },
        theme: {
          font: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap',
          css: {
            '.ps-submit': { backgroundColor: session.family === 'sport' ? '#4b172b' : '#c34a1b', color: '#ffffff', borderRadius: '7px', fontWeight: 700 },
            '.ps-field-label': { color: '#202124', fontWeight: 700 },
            '.ps-field-input': { borderColor: '#dadde2', borderRadius: '6px' },
          },
        },
      },
      onReady: () => {
        widgetReady = true;
        paymentSubmit.disabled = Number.isFinite(reservationDeadline) && Date.now() + serverClockOffsetMs >= reservationDeadline;
        status('', false);
      },
      onError: () => {
        widgetReady = false;
        paymentSubmit.disabled = true;
        status(copy.paysightUnavailable, true);
      },
      onMessage: handleMessage,
    });
  }

  async function refresh() {
    let session = await getSession();
    // A legacy payment can still be in flight during a frontend release. Do
    // not turn that already-submitted session into a customer-required one.
    if (session.status === 'open' && session.checkoutVersion === 2 &&
        !activationComplete && !paymentSignaled && !paymentSubmitting) {
      if (!activationPromise) activationPromise = activateCheckout().finally(() => { activationPromise = null; });
      session = await activationPromise;
    }
    if (session.status === 'not_found' || session.status === 'expired') {
      clearReservationCountdown();
      if (paymentStartedRecovered && Number.isFinite(Date.parse(session.expiresAt)) &&
          Number.isFinite(Date.parse(session.serverNow)) &&
          Date.parse(session.serverNow) > Date.parse(session.expiresAt) + 3600000) {
        paymentStartedRecovered = false;
        paymentSignaled = false;
        try { sessionStorage.removeItem(paymentStartedKey); } catch (_error) { /* storage may be disabled */ }
      }
      if (reviewing) { showReview(); schedulePoll(20000); }
      else if (paymentSignaled || paymentSubmitting) { showProcessing(true); schedulePoll(10000); }
      else showResult(copy.expired, '', returnButton.dataset.hasProduct === 'true');
      return;
    }
    if (!validSession(session)) {
      showResult(copy.unavailable, '', returnButton.dataset.hasProduct === 'true');
      return;
    }
    const deadline = typeof session.expiresAt === 'string' ? Date.parse(session.expiresAt) : NaN;
    const serverNow = typeof session.serverNow === 'string' ? Date.parse(session.serverNow) : Date.now();
    if (session.status === 'open' && Number.isFinite(deadline) && deadline <= serverNow && !paymentSubmitting) {
      setReturnPath(session.returnPath, session.family);
      showResult(copy.expired, '', returnButton.dataset.hasProduct === 'true');
      return;
    }
    baseSession = session;
    renderReservationCountdown(session);
    customerLocked = session.customerLocked === true || customerLocked;
    syncCustomerRetryNote();
    money = new Intl.NumberFormat(session.currency === 'USD' ? 'en-US' : (navigator.language || 'en-US'), {
      style: 'currency', currency: session.currency,
    });
    currencyNote.textContent = 'Charged in ' + session.currency;
    setReturnPath(session.returnPath, session.family);
    renderSummary(session);
    syncShippingMessage();
    updateCurrencyEstimate(session);
    renderFamily(session.family);
    if (session.status === 'complete') {
      try { sessionStorage.removeItem(pendingKey); } catch (_error) { /* storage may be disabled */ }
      try { sessionStorage.removeItem(paymentStartedKey); } catch (_error) { /* storage may be disabled */ }
      try {
        await applyUpsellState(await getUpsellState());
      } catch (_error) {
        if (currentChild) {
          showOffer(currentOffer, true);
          setOfferStatus(copy.verificationDelayed, false);
          schedulePoll(10000);
        } else {
          // The initial paid order is complete; upsell service failure must not hide it.
          showResult(copy.successHeading, copy.successBody, false);
        }
      }
      return;
    }
    if (session.status === 'review' || reviewing) {
      showReview();
      schedulePoll(15000);
      return;
    }
    if (session.status === 'confirming' || paymentSignaled) {
      showProcessing(Date.now() - openedAt > 45000);
      schedulePoll(3000);
      return;
    }
    if (session.status !== 'open') {
      showResult(copy.unavailable, '', true);
      return;
    }
    try {
      await mountWidget(session);
      schedulePoll(20000);
    } catch (_error) {
      showResult(copy.paysightUnavailable, '', true);
    }
  }

  if (!/^[A-Za-z0-9_-]{10,50}$/.test(sessionId)) {
    showResult(copy.expired, '', false);
    return;
  }
  try {
    const startedAt = Number(sessionStorage.getItem(paymentStartedKey));
    paymentStartedRecovered = Number.isSafeInteger(startedAt) && startedAt > 0 &&
      startedAt <= Date.now() + 300000 && Date.now() - startedAt <= 66 * 60000;
    if (!paymentStartedRecovered) sessionStorage.removeItem(paymentStartedKey);
    paymentSignaled = sessionStorage.getItem(pendingKey) === '1' || paymentStartedRecovered;
  } catch (_error) { /* storage may be disabled */ }
  status(copy.loading, false);
  refresh().catch(() => showResult(copy.unavailable, '', false));
})();
